import axios from '../../../axios'

export default {
  getLogBook (filter) {
    return axios.get('axleshunt/logbook' + filter).then(response => response.data)
  },
  addLogBook (data) {
    return axios.post('axleshunt/logbook', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/axleshunt/AxleShuntApi.js